import classNames from 'classnames';
import Image from 'next/image';

import styles from './CircleIcon.module.scss';

const CircleIcon = ({
  small,
  path,
  alt = 'icon',
  isSmall,
  className,
  children,
}) => {
  const renderImgOrText = (() => {
    if (children) {
      return (
        <span
          className={styles['circle-icon__text']}
          itemScope
          itemType='https://schema.org/Text'
        >
          {children}
        </span>
      );
    }

    return (
      <Image
        className={classNames([
          { 'circle-icon--small': isSmall },
          styles['circle-icon'],
        ])}
        src={path}
        alt={alt}
        title={alt}
        width={32}
        height={32}
        loading='lazy'
        itemScope
        itemType='https://schema.org/ImageObject'
      />
    );
  })();

  return (
    <div
      className={classNames(className, styles['circle-icon__wrapper'], {
        [styles.small]: small,
      })}
      itemScope
      itemType='https://schema.org/Property'
      data-testid='circle-icon'
    >
      {renderImgOrText}
    </div>
  );
};

export default CircleIcon;
